import React, { PropsWithChildren } from 'react'
import { ProgramFeatures } from '@citruscamps/citrus-client'
import { useFlags } from '../hooks/useFlags'

interface IProps
  extends React.DetailedHTMLProps<
    React.FieldsetHTMLAttributes<HTMLFieldSetElement>,
    HTMLFieldSetElement
  > {
  flagKey: keyof ProgramFeatures | (keyof ProgramFeatures)[]
  check?: (value?: boolean | number | string, key?: string) => boolean
  checkAll?: (flags: ProgramFeatures) => boolean
}

export const FieldsetFlag = ({
  flagKey,
  check = (val) => !!val,
  checkAll,
  children,
  disabled,
  ...props
}: PropsWithChildren<IProps>) => {
  const { flags, isLoading, isError } = useFlags()
  const isEnabled: boolean =
    (!!flags &&
      (checkAll
        ? checkAll(flags)
        : Array.isArray(flagKey)
        ? flagKey.every((flagKey) => check(flags[flagKey], flagKey))
        : check(flags[flagKey], flagKey))) ||
    isLoading ||
    isError
  return (
    <fieldset
      disabled={!isEnabled || disabled}
      style={!isEnabled ? { pointerEvents: 'none', userSelect: 'none', opacity: 0.6 } : undefined}
      {...props}
    >
      {children}
    </fieldset>
  )
}
